import { render, staticRenderFns } from "./listConsulting.vue?vue&type=template&id=0b798bcb&"
import script from "./listConsulting.vue?vue&type=script&lang=js&"
export * from "./listConsulting.vue?vue&type=script&lang=js&"
import style0 from "./listConsulting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports